import { render, staticRenderFns } from "./PurchaseConfirmation.vue?vue&type=template&id=12a11fda&scoped=true&"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=js&"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseConfirmation.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./PurchaseConfirmation.vue?vue&type=style&index=1&id=12a11fda&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12a11fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VApp,VCard,VCardText,VCardTitle})
